import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftRoute } from '..';

export const offeringsDraftUpdatedInformationRoute = createRoute({
  getParentRoute: () => offeringsDraftRoute,
  path: 'updated-info',
  component: lazyRouteComponent(() => import('./OfferingsDraftUpdatedInformationView')),
});
